import { Component, Prop, Watch } from 'vue-property-decorator'
import { MaintenaceViewmodal } from './maintenance.viewmodal'
import { namespace } from 'vuex-class'
import { SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS_FORCE } from '../../../../store/search'
import { SearchEntities, UserTemplate } from '../../../../common/enums'
import { MAINTENANCE_GET_INTERVAL_TYPES, MAINTENANCE_GET_TEMPLATES, MAINTENANCE_MODULE_NAMESPACE } from '../../../../store/maintenance'
import { MaintenanceService, TicketService } from '../../../../services'
import { eventBus } from '../../../../main'
import { SERIVCEBOOK_MODULE_NAMESPACE } from '../../../../store/service-book'
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store'
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { IUserDetails } from '../../../../models/user';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE);




@Component({
  components: {
    'ticket-group-round-buttons': async () => import('../../../ticket/components/ticket-modal-group-round-buttons/TicketModalGroupRoundButtons.vue'),
    'mandate-quote-selector': async () => import('../../../ticket/components/ticket-mandate-or-quote-selector/TicketMandateOrQuoteSelector.vue')
  }
})
class BlockMaintenanceModalVertical extends MaintenaceViewmodal {

  @UserStore.Getter userInfo: IUserDetails;

  @Prop({ default: false, type: [Boolean] })
  isUpdateMaintenance: boolean

  //isScheludeEquipmentMaintenance
  @Prop({ default: false, type: [Boolean] })
  isScheludeEquipmentMaintenance: boolean

  @Prop({ default: {}, type: [Object] })
  maintenanceData: any

  @Watch('type')
  typeChange() {
    this.getContractors()
  }

  @Watch('showAllContractor')
  showAllContractorChange() {
    this.getContractors()
  }

  @Watch('FKEquipmentCategory')
  catEquipmentChanged() {
    this.FKEquipmentSubCategory = null
    this.FKEquipment = null
    this.getEquipments()
  }

  @Watch('FKEquipmentSubCategory')
  subCatEquipmentChanged() {
    this.getEquipments()
  }

  @Watch('date')
  dateChanged(val) {
    this.dateFormatted = this.formatDate(this.date)
  }

  @Watch('FKEquipment')
  equipmentChanged(val) {
    if (this.FKMaintenanceTemplate && val) {
      this.maintenanceAPI.getEquipment(val.toString()).then(data => {
        this.attributes = data.attributes.filter(at => at.used_by_maintenance === true)
        const template = this.coMaintenanceTemplate.find(item => item.id === this.FKMaintenanceTemplate)
        this.FKAttribute = template.fk_maint_attribute
        this.FKMaintenanceIntervalType = template.fk_maint_interval_type
        this.$nextTick(() => {
          this.interval = template.interval
          this.alertPreDelay = template.alert_pre_delay
        })
      })
    }
    else {
      this.FKAttribute = null
      this.getAttributes()
      this.preSelectSubCategory()
    }

  }

  @Watch('FKMaintenanceIntervalType')
  intervalTypeChanged(val) {
    if (val) {
      this.interval = null
      this.alertPreDelay = null
      const intervalType = this.maintenanceIntervalTypes.find(item => item.id === val)
      this.intervalUnit = intervalType.name
      this.alertUnit = 'Jour'
    }
  }

  @Watch('FKAttribute')
  attributChanged(val) {
    if (val) {
      this.attribut_value_maintenance = null
      this.FKMaintenanceIntervalType = null
      this.interval = null
      this.alertPreDelay = null

      const attribut = this.attributes.find(item => item.id === val)
      this.attributType = attribut.attribute_type.type
      if (attribut.attribute_value) {
        this.currentAttributValue = attribut.attribute_value.value
        this.currentAttributUnit = attribut.unit
        if (this.attributType === 'number') {
          this.FKMaintenanceIntervalType = 1
          this.$nextTick(() => {
            this.intervalUnit = attribut.unit
            this.alertUnit = attribut.unit
          })
        }
      }
      else {
        this.FKMaintenanceIntervalType = 1
        this.$nextTick(() => {
          this.currentAttributValue = 0
          this.currentAttributUnit = attribut.unit
          this.intervalUnit = attribut.unit
          this.alertUnit = attribut.unit
        })
      }
    }
    else {
      this.attributType = 'date'
      this.currentAttributValue = null
      this.currentAttributUnit = null
      this.FKMaintenanceIntervalType = null
    }
  }

  @Watch('FKMaintenanceTemplate')
  maintenanceTemplateChanged(val) {
    // ==== initialize values
    this.type = null
    this.name = null
    this.description = null
    this.FKEquipmentCategory = null
    this.FKEquipmentSubCategory = null
    this.FKAttribute = null
    this.FKMaintenanceIntervalType = null
    this.interval = null

    if (val) {
      const template = this.coMaintenanceTemplate.find(item => item.id === val)
      this.type = template.type
      this.name = template.name
      this.description = template.description
      this.FKEquipmentCategory = template.fk_character_problem
      this.$nextTick(() => {
        this.FKEquipmentSubCategory = template.fk_character_problem_level_2
      })
    }
  }

  @MaintenanceStore.Getter maintenanceIntervalTypes: { name: string, id: number, type: string }[]
  @MaintenanceStore.Getter maintenanceTemplates: {
    name: string,
    id: number,
    type: string,
    description: string,
    fk_character_problem: number,
    fk_character_problem_level_2: number,
    fk_maint_interval_type: number
    interval: number
    fk_maint_attribute: number
    alert_pre_delay: number
  }[]

  @ServiceBookStore.Getter currentServiceBook: IServiceBookDetails

  @MaintenanceStore.Action(MAINTENANCE_GET_TEMPLATES)
  storeGetMaintenanceTemplate: (params: any) => Promise<any>;

  @MaintenanceStore.Action(MAINTENANCE_GET_INTERVAL_TYPES)
  storeGetMaintenanceIntervalTypes: () => Promise<any>;


  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetMasterData: (payload?: { keys: SearchEntities[] }) => Promise<any>;


  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  dtRules: {}
  managers: any[];
  contractors: any[];
  isContactorLoading: boolean;
  isManagerLoading: boolean;
  isCategoriesLoading: boolean;
  charProblemAPI: any
  maintenanceAPI: any
  equipmentCategories: any[]
  equipments: any[]
  attributes: any[]
  FKEquipmentCategory: number
  FKEquipmentSubCategory: number
  showAllContractor: boolean
  selectDateLastMaint: boolean
  dateFormatted: string
  intervalUnit: string
  alertUnit: string
  attributType: string
  currentAttributValue: string | number | null
  currentAttributUnit: string | null
  dialog: { isOpen: boolean, title: string, message: string, btnText: string, action: Function }
  isUpdateEquipmentAttr: boolean
  isEditEquipmentAttr: boolean
  isLoading: boolean


  constructor() {
    super()
    this.dtRules = {}
    this.managers = []
    this.contractors = []
    this.type = 'mandatory'
    this.isContactorLoading = true
    this.isManagerLoading = true
    this.isCategoriesLoading = true
    this.charProblemAPI = new TicketService()
    this.maintenanceAPI = new MaintenanceService()
    this.equipmentCategories = []
    this.equipments = []
    this.attributes = []
    this.FKEquipmentCategory = null
    this.FKEquipmentSubCategory = null
    this.showAllContractor = false
    this.selectDateLastMaint = false
    this.dateFormatted = null
    this.intervalUnit = null
    this.alertUnit = null
    this.attributType = 'date'
    this.currentAttributValue = null
    this.currentAttributUnit = null
    this.dialog = {
      isOpen: false,
      title: 'title',
      message: 'message',
      btnText: 'Action',
      action: () => { console.log('Action') }
    }
    this.isUpdateEquipmentAttr = false
    this.isEditEquipmentAttr = false
    this.isLoading = false
  }

  beforeDistroy() {
    eventBus.$off('SET_ISLOADING_MODAL_MAINTENANCE')
  }

  async beforeMount() {

    eventBus.$on('SET_ISLOADING_MODAL_MAINTENANCE', val => {
      this.isLoading = val
    })

    this.isLoading = true
    this.dateFormatted = this.formatDate(this.date)
    await this.storeGetMaintenanceTemplate({ $limit: 50 })
    await this.storeGetMaintenanceIntervalTypes()

    const _categories = await this.charProblemAPI.getCharacterProblems()
    this.equipmentCategories = _categories.level_1
    this.isCategoriesLoading = false

    // load contractors
    let contractorPayload: any = {
      entity: [SearchEntities.Contractor],
      block: [parseInt(this.$route.params.id)]
    }
    if (this.showAllContractor) { delete contractorPayload.block }
    this.contractors = await this.storeGetEntitySearch(contractorPayload)
    this.isContactorLoading = false
    this.managers = await this.storeGetEntitySearch({ entity: [SearchEntities.Manager] })
    this.isManagerLoading = false

    this.dtRules = {
      nameRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceName) })],
      descriptionRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceDescription) })],
      typeRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceType) })],
      stateRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceState) })],
      methodRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceMethod) })],
      CategorieRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceEquipementCategorie) })],
      EquipementRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceEquipement) })],
      LastMaintDateRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceDate) })],
      managerRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceManager) })],
      contractorRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceContractor) })],
      IntervalTypeRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceIntervalType) })],
      IntervalRules: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceInterval) })],
      alertPreDelay: [v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceAlertPreDelay) })],
      AttributMaintVal: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.labelMaintenanceAttribute) }),
        v => v < this.currentAttributValue || this.$t(this.lblSetting.requireAttributeValSuperior, { value: `${this.currentAttributValue} ${this.currentAttributUnit}`, type: this.$t(this.lblSetting.labelAttributValue) }),
      ]
    }

    // === in case update maintenance
    if (this.isUpdateMaintenance) {
      console.log(this.maintenanceData)
      this.state = this.maintenanceData.state
      this.type = this.maintenanceData.type
      this.manager = this.maintenanceData.fk_entity_manager_assign
      this.showAllContractor = true
      this.contractor = this.maintenanceData.fk_entity_contractor
      this.name = this.maintenanceData.name
      this.description = this.maintenanceData.description
      this.name = this.maintenanceData.name
      this.FKEquipmentCategory = this.maintenanceData.equipment.category.id

      this.$nextTick(() => {
        this.FKEquipmentSubCategory = this.maintenanceData.equipment.subcategory ? this.maintenanceData.equipment.subcategory.id : null
        this.FKEquipment = this.maintenanceData.equipment.id
        this.$nextTick(() => {
          this.method = this.maintenanceData.method
          this.maintenanceAPI.getEquipment(this.FKEquipment.toString()).then(data => {
            this.attributes = data.attributes.filter(at => at.used_by_maintenance === true)
            this.FKAttribute = this.maintenanceData.fk_attribute
            this.$nextTick(() => {
              this.dateFormatted = this.formatDate(this.maintenanceData.last_maintenance_date.split('T')[0])
              this.attribut_value_maintenance = this.maintenanceData.last_maintenance_value
              this.FKMaintenanceIntervalType = this.maintenanceData.fk_interval_type
              this.$nextTick(() => {
                this.interval = this.maintenanceData.interval
                this.alertPreDelay = this.maintenanceData.alert_pre_delay
                this.isLoading = false
              })
            })
          })
        })
      })
    } else if (this.isScheludeEquipmentMaintenance) {
      this.FKEquipmentCategory = this.maintenanceData.FKEquipmentCategory
      this.$nextTick(() => {
        this.FKEquipmentSubCategory = this.maintenanceData.FKEquipmentSubCategory
        this.$nextTick(() => {
          this.FKEquipment = this.maintenanceData.FKEquipment
          this.isLoading = false
        })
      })
    }
    else {
      this.isLoading = false
    }
  }

  fetchTemplates(val) {
    return this.storeGetMaintenanceTemplate({ q: val, $limit: 50 })
  }


  editEquipmentAttribut() {
    if (this.isEditEquipmentAttr) {
      this.isUpdateEquipmentAttr = true
      const equipment = this.coEquipments.find(item => item.id === this.FKEquipment)
      this.maintenanceAPI.patchEquipmentAttribute(equipment.id, this.FKAttribute, { value: this.currentAttributValue }).then(data => {
        this.isUpdateEquipmentAttr = false
        this.isEditEquipmentAttr = false
      }).catch(e => {
        this.isUpdateEquipmentAttr = false
        this.isEditEquipmentAttr = false
      })
    }
    else {
      this.isEditEquipmentAttr = !this.isEditEquipmentAttr
    }
  }

  getAttributes() {
    if (this.FKEquipment) {
      this.maintenanceAPI.getEquipment(this.FKEquipment.toString()).then(data => {
        this.attributes = data.attributes.filter(at => at.used_by_maintenance === true)
      })
    }
  }

  preSelectSubCategory() {
    let selectedEquipment = this.coEquipments.find(eq => eq.id === this.FKEquipment)
    if (selectedEquipment) {
      let subCategorie = selectedEquipment.fk_character_problem_lvl2
      this.FKEquipmentSubCategory = subCategorie
      console.log({
        FKEquipment: this.FKEquipment,
        selectedEquipment,
        coEquipments: this.coEquipments
      })
    }
  }

  getEquipments() {
    if (this.FKEquipmentCategory) {
      const blokId = this.$route.path.includes('service-book') ? this.currentServiceBook.apartment.fk_apartment_block : this.$route.params.id
      this.charProblemAPI.getEquipments({ block: blokId, char1: this.FKEquipmentCategory, char2: this.FKEquipmentSubCategory, $limit: 50 }).then(data => {
        this.equipments = data.data
      })
    } else {
      this.FKEquipment = null
      this.FKAttribute = null
    }
  }


  formatDate(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  getContractors() {
    this.isContactorLoading = true
    let contractorPayload: any = {
      entity: this.getContractorsType(),
      block: [parseInt(this.$route.params.id)]
    }
    if (this.showAllContractor) { delete contractorPayload.block }
    this.storeGetEntitySearch(contractorPayload).then(data => {
      this.contractors = data
      this.isContactorLoading = false
    })
  }

  handleGetManagers(key: string) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.Manager],
      query: key,
    })
  }

  getContractorsType() {
    if (this.type === 'mandatory') {
      return [SearchEntities.Contractor]
    }
    else if (this.type === 'external') {
      return [SearchEntities.IndependentContractor]
    }
    else if (this.type === 'internal') {
      return [SearchEntities.InternalContractor]
    }
    else {
      return [SearchEntities.Contractor]
    }
  }

  handleGetContractors(key: string) {
    return this.storeGetEntitySearch({
      entity: this.getContractorsType(),
      query: key,
    })
  }

  handleGetEquipements(key: string) {
    return this.charProblemAPI.getEquipments({ char1: this.FKEquipmentCategory, char2: this.FKEquipmentSubCategory, q: key, $limit: 1000, $skip: 0 })
      .then(data => {
        this.equipments = data.data
      })
  }

  get lblSetting() {
    return {
      ...require('@/locales/maintenance').default,
      ...require('@/locales/validation-messages').default
    }
  }

  get textConfigs() {
    return require('@/assets/json-resources/text-field-configs.json')
  }
  get isServiceBookUser(): boolean {
    return this.userInfo.template === UserTemplate.serviceBookAgency
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }
  get coTypes() {
    //
    if (this.isServiceBookUser || this.isServiceBookOwner)
      return [
        { key: 2, translationKey: 'Obligatoire', value: 'mandatory' },
        { key: 1, translationKey: 'Standard', value: 'default' }

      ]
    return [
      { key: 1, translationKey: 'Obligatoire', value: 'mandatory' },
      { key: 2, translationKey: 'Externe', value: 'external' },
      { key: 3, translationKey: 'Interne', value: 'internal' },
    ]
  }

  get coType() {
    if (this.isServiceBookUser || this.isServiceBookOwner)
      return [
        { id: 'mandatory', name: 'Obligatoire' },
        { id: 'default', name: 'Standard' },
      ]
    return [
      { id: 'mandatory', name: 'Obligatoire' },
      { id: 'external', name: 'Externe' },
      { id: 'internal', name: 'Interne' },
    ]
  }

  get coState() {
    return [
      { id: 'waiting', name: 'En attente' },
      { id: 'triggered', name: 'Déclenchée' },
      { id: 'done', name: 'Terminée' },
      { id: 'archived', name: 'Archivée' },
      { id: 'disabled', name: 'Désactivée' },
    ]
  }

  get coMaintenanceIntervalType() {
    return this.maintenanceIntervalTypes.filter(item => item.type !== 'value');
  }

  get coMaintenanceTemplate() {
    return this.maintenanceTemplates;
  }

  get coEquipmentCategories() {
    return this.equipmentCategories
  }

  get coEquipmentSubCategories() {
    let r: any = this.equipmentCategories.find((cat: { id: number }) => cat.id === this.FKEquipmentCategory)
    return r ? r.level_2 : []
  }

  get coEquipments() {
    return this.equipments
  }

  get coAttributes() {
    return this.attributes
  }



  get coManagers() {
    return [...(this.managers || [])];
  }

  get coContractors() {
    return [...(this.contractors || [])];
  }
}

export default BlockMaintenanceModalVertical



// WEBPACK FOOTER //
// ./src/containers/block/components/block-maintenance-modal-vertical/index.ts